import React from 'react';
import "./footer.css"

function Footer() {
    return (
        <div className="footer">
         🔥 Made with ❤️ by 💻 Yash Sahsani
        </div>
    )
}

export default Footer
